import React from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';
import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors
} from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy
} from '@dnd-kit/sortable';

import * as S from './styles';
import { color } from 'styles/pallete';
import { BannerFromCarrosselBannersProps } from 'types/BannerFromCarrosselBannersProps';
import { SortableItem } from 'components/DnDSortalbe/SortableItem';
import { formatDateToView, shrinkText } from 'utils/functions';

interface ListDragableBannersProps {
	listBanners: BannerFromCarrosselBannersProps[];
	setListBanners: React.Dispatch<
		React.SetStateAction<BannerFromCarrosselBannersProps[]>
	>;
	setSizeBanner: React.Dispatch<
		React.SetStateAction<{
			width: number;
			height: number;
		}>
	>;
	setBannerToEdit: React.Dispatch<
		React.SetStateAction<BannerFromCarrosselBannersProps | null>
	>;
	setIsFormBannerOpen: React.Dispatch<React.SetStateAction<boolean>>;
	returnNameRedirectByIdDynamicScreen: any;
	deleteBanner: any;
}

export default function ListDragableBanners({
	listBanners,
	returnNameRedirectByIdDynamicScreen,
	deleteBanner,
	setSizeBanner,
	setBannerToEdit,
	setIsFormBannerOpen,
	setListBanners
}: ListDragableBannersProps) {
	function handleDragEnd(event: any) {
		const { active, over } = event;
		if (active.id !== over.id) {
			const oldIndex = listBanners.findIndex(
				(item) => item.idFront === active.id
			);
			const newIndex = listBanners.findIndex(
				(item) => item.idFront === over.id
			);
			setListBanners((prev) => arrayMove(prev, oldIndex, newIndex));
		}
	}

	const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 5 // Evita que pequenos cliques iniciem um drag
			}
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates
		})
	);
	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				id="items"
				items={listBanners.map((item, i) => ({ id: item.idFront || i }))}
				strategy={verticalListSortingStrategy}
			>
				<S.listBanner>
					{listBanners.length > 0 ? (
						listBanners.map((item, i: any) => (
							<SortableItem
								id={item.idFront || i}
								key={item.image.id}
								lockAxisX
							>
								<S.banner key={item.image.id}>
									<img src={item.image.relativePath} />

									<S.content>
										<p>
											<b>Tipo de redirecionamento:</b> {item.redirect.type}
										</p>

										<p>
											<b>Valor</b> :{' '}
											{item.redirect.type === 'app_screen'
												? returnNameRedirectByIdDynamicScreen(
														item.redirect.value
													)
												: item.redirect.value}
										</p>

										{item?.description && (
											<>
												<p>
													<b>Título do baner:</b> {item.description.title}
												</p>
												<p>
													<b>Subtítulo do baner:</b> {item.description.subTitle}
												</p>
												<p>
													<b>Descrição do baner:</b>{' '}
													{shrinkText(item.description.descriptionText, 30)}
												</p>
											</>
										)}
										{item.schedule && (
											<p>
												<b>Agendamento</b> : Data incicio:{' '}
												{item.schedule?.start !== ''
													? formatDateToView(item.schedule?.start, true, -3)
													: 'Sem data'}{' '}
												- Data fim:
												{item.schedule?.end !== ''
													? formatDateToView(item.schedule?.end, true, -3)
													: 'Sem data'}
											</p>
										)}
									</S.content>

									<S.actions>
										<MdDelete
											onClick={() => deleteBanner(item?.idFront || '')}
											color={color.system.error}
										/>
										<MdEdit
											onClick={() => {
												if (listBanners.length === 1 && i === 0) {
													setSizeBanner({ height: 9999, width: 9999 });
												}
												setBannerToEdit(item);
												setIsFormBannerOpen(true);
											}}
											color={color.interface.darkgray3}
										/>
									</S.actions>
								</S.banner>
							</SortableItem>
						))
					) : (
						<S.noBanner>
							<p>Não há banners cadastrado</p>
						</S.noBanner>
					)}
				</S.listBanner>
			</SortableContext>
		</DndContext>
	);
}
